import React from 'react';
import Wrapper from './styles';
import { Link } from 'react-router-dom';
import { useLanguageContext } from '../../context/language_context';

const PageHero = ({ title, product }) => {
  const { t } = useLanguageContext();
  
  return (
    <Wrapper>
      <div className='section-center'>
        <h3>
          <Link to='/'>{t.nav.home}</Link>
          {product && <Link to='/products'>/ {t.nav.products}</Link>}/ {title}
        </h3>
      </div>
    </Wrapper>
  );
};

export default PageHero;
